import { Typography } from "@mui/material";
import React from "react";
import Tilt from "react-parallax-tilt";
import "./tiltSol.css";

const ParallaxCards = () => {
  const cards = [
    {
      title: "Multi-Platform Apps",
      description:
        "Distribute your content across all platforms by publishing apps across Mobile, Web, Desktop, TV, Smart Boxes and increase your reach and revenues!"
    },
    {
      title: "Cost Efficient",
      description:
        "Leverage Horizon affordable pricing plans to Monetize your OTT strategy."
    },
    {
      title: "Real Time Analytics",
      description:
        "Track User Level, Video Level and Aggregate Analytics and improve your monetisation and content strategy for wider reach!"
    }
  ];

  return (
    <div style={{ padding: "2rem" }} >
      <Typography
        style={{
          textAlign: "center",
          fontSize: "32px",
          fontWeight: "700",
          fontFamily: "system-ui",
          color: "#6054E4",
          marginBottom: "2rem"
        }}
      >
        Why use our Solution?
      </Typography>

      <div className="cards-container">
        {cards.map((card, index) => (
          <Tilt
            key={index}
            perspective={800}
            tiltMaxAngleX={35}
            tiltMaxAngleY={35}
            transitionSpeed={2000}
            scale={1.05}
            gyroscope={true}
            className="parallax-card"
          >
            <h3>{card.title}</h3>
            <hr className="card-divider" />
            <p>{card.description}</p>
          </Tilt>
        ))}
      </div>
    </div>
  );
};

export default ParallaxCards;
